export default (startUrlSuffix?: string) => {
  const firstConfig = generateConfig();

  function generateConfig(suffix?: string): IManifestConfig {
    const startUrl = suffix ? `/${suffix}/` : '/index.html';

    return {
      background_color: '#ffffff',
      display: 'fullscreen',
      icons: [
        {
          sizes: '192x192',
          src: 'https://texn-kiosk.firebaseapp.com/android-chrome-192x192.png',
        },
        {
          sizes: '384x384',
          src: 'https://texn-kiosk.firebaseapp.com/android-chrome-384x384.png',
        },
      ],
      lang: '',
      name: 'TexnRewards Kiosk',
      orientation: 'any',
      short_name: 'Kiosk',
      start_url: startUrl,
      theme_color: '#ffffff',
    };
  }

  function generateManifest(config: IManifestConfig) {
    const manifestTag = document.getElementById('manifest-placeholder');

    const configString = JSON.stringify(config);
    const configBlob = new Blob([configString], { type: 'application/json' });
    const configURL = URL.createObjectURL(configBlob);

    if (manifestTag) {
      manifestTag.setAttribute('href', configURL);
    }
  }

  if (startUrlSuffix) {
    generateManifest(generateConfig(startUrlSuffix));
  } else {
    generateManifest(firstConfig);
  }
};

interface IManifestConfigIcon {
  sizes: string;
  src: string;
}

interface IManifestConfig {
  background_color: string;
  display: 'fullscreen';
  icons: IManifestConfigIcon[];
  lang: string;
  name: string;
  orientation: string;
  short_name: string;
  start_url: string;
  theme_color: string;
}



// WEBPACK FOOTER //
// ./src/generateManifest.ts